import styled, { css } from 'styled-components';
import { modalCloseButton } from '../../closeButtonStyles.ts';

export const HeaderWrapper = styled.div<{ $showShadow?: boolean }>`
  background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundPage};

  ${({ $showShadow, theme }) =>
    $showShadow &&
    css`
      box-shadow: ${theme.kallisto.shadow.mediumDownShadow};
      border-bottom: 1px solid ${theme.kallisto.color.border.static.borderNeutral};
    `}
`;

export const ModalHeaderContainer = styled.div<{ $align?: 'center' | 'left' }>`
  min-height: 64px;
  padding: 14px ${({ $align }) => ($align === 'left' ? '24px' : '48px')};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${({ $align }) => ($align === 'left' ? 'flex-start' : 'center')};
  width: 100%;
  background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundPage};
  position: relative;
  ${({ theme }) => theme.kallisto.mixins.font('Title4')};

  svg {
    line {
      stroke: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
      stroke-width: 1;
    }
  }
`;

export const CloseIconContainer = styled.button`
  position: absolute;
  top: 12px;
  right: 8px;
  z-index: 2;
  ${modalCloseButton}
`;
